import { render } from "./BasicUsage.vue?vue&type=template&id=3e68dc9d"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"
script.render = render

export default script